import ThumbnailCreator from './ThumbnailCreator.js';

export default ThumbnailCreator;
